import { BlockType, SwitchBlock } from '../switchBlock/SwitchBlock';
import style from './StandardBlocksLayout.module.scss';
import defaultBlockStyles from './default-block-styles.module.scss';
import { DESKTOP_BREAKPOINT } from 'pages/_app';
type Props = { blocks: BlockType[]; blockStyles?: string; sizes?: string };

export const StandardBlocksLayout = ({ blocks, blockStyles, sizes }: Props): JSX.Element => {
  let prevIsMedia = false;
  let prevType = '';
  return (
    <>
      {blocks.map((block, index) => {
        let layoutState = block.size ? style[block.size] : style.regular;

        if (
          (block.block_type === 'text' && block.size !== 'large') ||
          block.block_type === 'stats'
        ) {
          layoutState = block.position ? style[block.position] : style.regular;
        }

        if (block.block_type === 'media' && block.size === 'half') {
          layoutState = block.position ? style[block.position] : style.regular;
        }
        const blockState = block.size ? defaultBlockStyles[block.size] : '';
        const isFirstBlock = index === 0 ? 'js-first-block' : null;
        const currentIsMediaOrGallery =
          block.block_type === 'gallery' ||
          block.block_type === 'media' ||
          block.block_type === 'grid';

        const prevIsAlsoMediaState =
          currentIsMediaOrGallery && prevIsMedia ? `blocks__prevIsSame` : null;

        const prevClass = `blocks__prevIs${prevType}`;

        //has to be the last
        prevIsMedia = currentIsMediaOrGallery;
        prevType = block.block_type;
        const finalSizes = sizes || getSize(block);
        return (
          <section
            key={index}
            className={`blocks ${style.section} ${prevClass} ${prevIsAlsoMediaState} ${isFirstBlock} ${layoutState} ${defaultBlockStyles.blocks} ${blockStyles} ${blockState}`}
          >
            <div className={`${prevIsAlsoMediaState} ${prevClass} `}>
              <SwitchBlock block={block} sizes={finalSizes} />
            </div>
          </section>
        );
      })}
    </>
  );
};
function getSize(block: BlockType): string {
  if (block.block_type === 'grid') {
    return `${DESKTOP_BREAKPOINT} 40vw,
            100vw`;
  }
  switch (block.size) {
    case 'full':
      return '100vw';
    case 'half':
      return `${DESKTOP_BREAKPOINT} 40vw,
              100vw`;
    case 'large':
      return `${DESKTOP_BREAKPOINT} 90vw,
              100vw`;
    case 'medium':
      return `${DESKTOP_BREAKPOINT} 50vw,
              100vw`;

    default:
      return '100vw';
  }
}
